// extracted by mini-css-extract-plugin
export default {"label":"ChangeDiscountModal_label__vVqf3","value":"ChangeDiscountModal_value__4NiY6","submitButton":"ChangeDiscountModal_submitButton__9PPua"};